import { render } from "./account.view.vue?vue&type=template&id=9a025568&scoped=true&ts=true"
import script from "./account.view.vue?vue&type=script&lang=ts"
export * from "./account.view.vue?vue&type=script&lang=ts"

import "./account.view.vue?vue&type=style&index=0&id=9a025568&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a025568"]])

export default __exports__